import React from 'react';

export const TakeittoLogo = ({ size = 'md', showText = true, className = '' }) => {
  const sizes = {
    sm: { icon: 32, text: 'text-lg' },
    md: { icon: 40, text: 'text-xl' },
    lg: { icon: 56, text: 'text-2xl' }
  };
  
  const { icon, text } = sizes[size] || sizes.md;
  
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <svg 
        width={icon} 
        height={icon} 
        viewBox="0 0 64 64" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background circle with gradient */}
        <defs>
          <linearGradient id="takeittoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#6366F1" />
            <stop offset="50%" stopColor="#8B5CF6" />
            <stop offset="100%" stopColor="#A855F7" />
          </linearGradient>
          <linearGradient id="routeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#22D3EE" />
            <stop offset="100%" stopColor="#34D399" />
          </linearGradient>
        </defs>
        
        {/* Main circle background */}
        <circle cx="32" cy="32" r="30" fill="url(#takeittoGradient)" />
        
        {/* Inner glow effect */}
        <circle cx="32" cy="32" r="26" fill="none" stroke="white" strokeOpacity="0.2" strokeWidth="2" />
        
        {/* Stylized "T" for Takeitto */}
        <path 
          d="M18 21 L46 21" 
          stroke="white" 
          strokeWidth="4" 
          strokeLinecap="round" 
        />
        <path 
          d="M32 21 L32 44" 
          stroke="white" 
          strokeWidth="4" 
          strokeLinecap="round" 
        />
        
        {/* Navigation dot at bottom of stem */}
        <circle cx="32" cy="44" r="4" fill="url(#routeGradient)" />
        
        {/* Subtle route lines */}
        <path 
          d="M32 44 L32 52" 
          stroke="url(#routeGradient)" 
          strokeWidth="2" 
          strokeLinecap="round"
          strokeDasharray="2 2"
        />
        
        {/* Small location pins at the ends of the bar */}
        <circle cx="18" cy="21" r="3" fill="white" fillOpacity="0.9" />
        <circle cx="46" cy="21" r="3" fill="white" fillOpacity="0.9" />
      </svg>
      
      {showText && (
        <div className="flex flex-col">
          <span className={`font-bold tracking-tight bg-gradient-to-r from-indigo-600 via-purple-600 to-violet-600 bg-clip-text text-transparent ${text}`}>
            Takeitto
          </span>
          <span className="text-[10px] text-gray-500 -mt-0.5 tracking-wider uppercase">
            Logistics Platform
          </span>
        </div>
      )}
    </div>
  );
};

export const TakeittoIcon = ({ size = 24, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 64 64" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <defs>
      <linearGradient id="takeittoGradientIcon" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#6366F1" />
        <stop offset="50%" stopColor="#8B5CF6" />
        <stop offset="100%" stopColor="#A855F7" />
      </linearGradient>
      <linearGradient id="routeGradientIcon" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#22D3EE" />
        <stop offset="100%" stopColor="#34D399" />
      </linearGradient>
    </defs>
    <circle cx="32" cy="32" r="30" fill="url(#takeittoGradientIcon)" />
    <circle cx="32" cy="32" r="26" fill="none" stroke="white" strokeOpacity="0.2" strokeWidth="2" />
    <path d="M18 21 L46 21" stroke="white" strokeWidth="4" strokeLinecap="round" />
    <path d="M32 21 L32 44" stroke="white" strokeWidth="4" strokeLinecap="round" />
    <circle cx="32" cy="44" r="4" fill="url(#routeGradientIcon)" />
    <path 
      d="M32 44 L32 52" 
      stroke="url(#routeGradientIcon)" 
      strokeWidth="2" 
      strokeLinecap="round"
      strokeDasharray="2 2"
    />
    <circle cx="18" cy="21" r="3" fill="white" fillOpacity="0.9" />
    <circle cx="46" cy="21" r="3" fill="white" fillOpacity="0.9" />
  </svg>
);

export default TakeittoLogo;
